/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Tools_Waypoints_DescInputs */

const en_ui_studio_tools_waypoints_desc = /** @type {(inputs: Ui_Studio_Tools_Waypoints_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark points of interest along the route.`)
};

const de_ui_studio_tools_waypoints_desc = /** @type {(inputs: Ui_Studio_Tools_Waypoints_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere interessante Punkte entlang der Route.`)
};

/**
* | output |
* | --- |
* | "Mark points of interest along the route." |
*
* @param {Ui_Studio_Tools_Waypoints_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_tools_waypoints_desc = /** @type {((inputs?: Ui_Studio_Tools_Waypoints_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Tools_Waypoints_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_tools_waypoints_desc(inputs)
	return de_ui_studio_tools_waypoints_desc(inputs)
});